export default __webpack_public_path__ + "static/media/bigmart.4b5eaf80.png";